import { useGate as useStatsigGate } from 'statsig-react';

const useGate = (gateName: string): { value: boolean; isLoading: boolean } => {
  const { value, isLoading } = useStatsigGate(gateName);

  return { value, isLoading };
};

export default useGate;
